import React from 'react';
import { CallFieldMappingConfig } from '../../store/state/createJobState';
import { MappingRequirementType } from '../../models/mappingRequirementType';
import Tooltip from '../Tooltip';

const maxToShow = 4;

export default function CreateJobRequiredFieldsText(props: Props) {
	const required = props.mappings.filter(m => m.requirementType === MappingRequirementType.Required).map(m => m.displayName);
	if (!required)
		return null;
	
	const toShow = required.slice(0, maxToShow);
	const others = required.slice(maxToShow);
	
	return (
		<span>
			<span className="text-bold">Required fields: </span> 
			<span>{toShow.join(', ')}</span>
			
			{!!others.length &&
				<span>,
					<Tooltip content={others.join(', ')} placement="top">
						<span className="text-bold pretty-focus" tabIndex={0}>&nbsp;{others.length.toLocaleString()} more</span>
					</Tooltip>
				</span>
			}
		</span>
	)
}

interface Props {
	mappings: CallFieldMappingConfig[];
}
